import React from 'react';
import styles from './ScarcityBanner.module.css';

function ScarcityBanner({ onScrollToBeta }) {
  return (
    <div className={styles.scarcityHeader}>
      <div className={styles.scarcityContent}>
        <span className={styles.scarcityText}>
          <span className={styles.scarcityTextDesktop}>
            Restam apenas 20% das vagas disponíveis para obter acesso antecipado.
          </span>
          <span className={styles.scarcityTextMobile}>
            Últimas vagas disponíveis!
          </span>
        </span>
        {/**
        <button
          className={styles.scarcityButton}
          onClick={onScrollToBeta}
        >
          Começar meu teste grátis
        </button>*/}
      </div>
    </div>
  );
}

export default ScarcityBanner;